<template>
  <Row>
    <i-col span="24">
      <AffixHeader>
        <span slot="current">Communications</span>
        <span slot="title">Communications</span>
      </AffixHeader>

      <Card dis-hover>
        <h3 slot="title">Search</h3>
        <i-form :model="form" :label-width="90" label-position="right">
          <Row>
            <i-col span="24">
              <i-form-item label="Subject">
                <i-input v-model="form.subject"></i-input>
              </i-form-item>

              <i-form-item label="Date">
                <DatePicker
                  type="daterange"
                  v-model="form.conducted_at"
                  format="yyyy-MM-dd"
                  style="width:100%;"
                ></DatePicker>
              </i-form-item>

              <i-form-item label="Countries">
                <TagSelectCountry v-model="form.iso3"></TagSelectCountry>
              </i-form-item>
            </i-col>
          </Row>

          <Row type="flex" justify="end" style="margin:12px 0;">
            <i-form-item class="action-buttons">
              <i-button icon="search" @click="search">Search</i-button>
              <i-button icon="close" @click="reset">Reset</i-button>
            </i-form-item>
          </Row>
        </i-form>
      </Card>

      <br />
      <CommunicationsTable :conditions="conditions"></CommunicationsTable>
    </i-col>
  </Row>
</template>

<script>
import moment from "moment";
import CommunicationsTable from "@/communications/table.vue";
import TagSelectCountry from "@/components/tag_select_country_by_iso3";
import { getTsQueryValue } from "@/utils/common";

const emptyForm = {
  subject: "",
  iso3: [],
  conducted_at: [],
};

export default {
  components: { CommunicationsTable, TagSelectCountry },

  data() {
    return {
      form: Object.assign({}, emptyForm),
      conditions: {},
    };
  },

  methods: {
    search() {
      let conditions = {};

      // Name
      if (this.form.subject !== "") {
        conditions["subject"] = getTsQueryValue(this.form.subject)
      }

      // Date
      if (this.form.conducted_at.length > 0) {
        const start = moment(this.form.conducted_at[0]);
        const end = moment(this.form.conducted_at[1]);
        if (start.isValid() && start.isValid()) {
          conditions["and"] = `(conducted_at.gte.'${start.format(
            "YYYY-MM-DD"
          )}',conducted_at.lte.'${end.format("YYYY-MM-DD")}')`;
        }
      }

      // Sources
      if (this.form.iso3.length > 0) {
        conditions["iso3"] = `in.(${this.form.iso3.join(",")})`;
      }
      this.conditions = conditions;
    },

    reset() {
      this.form = Object.assign({}, emptyForm);
      this.conditions = {};
    },
  },
};
</script>

<style lang="css"></style>
